import React from 'react'
import styled from 'styled-components'
import { LINKS } from '../../../../../../Routs/config'
import { Link } from 'react-router-dom'
import LinkIcon from '../../../../../../generic/icons/IconLib/LinkIcon'

const InviteLink = () => {
  return (
    <MainWrapper>
      <span>
        <Link to={LINKS.auth.invite.mainURL}>
        לחץ כאן
        </Link>
      </span> 
      - להזמנת מגדלים למערכת  
      <LinkIcon />
    </MainWrapper>
  )
}
const MainWrapper = styled.div`
  display: flex;
  gap: 0.5em;
  padding: 0.5em 1em;
  border-radius: 10px;
  background-color: #fff;
  color: #297F76;
  font-size: 1em;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  span {
    // underline
    text-decoration: underline;
  }
`
export default InviteLink